import React from "react";
import { copyrightData } from "../../datos";

const Copyright = () => {
  const { text } = copyrightData;
  return (
    <div className="py-6">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2 text-white/35 text-sm">
            <span className="w-2 h-2 rounded-full bg-[#C81416]" />
            {text}
          </div>
          <div className="flex items-center gap-6 text-white/35 text-sm">
            <a href="/nosotros" className="hover:text-white transition-colors duration-200">Sobre Nosotros</a>
            <span className="text-white/15">|</span>
            <a href="/contacto" className="hover:text-white transition-colors duration-200">Contacto</a>
            <span className="text-white/15">|</span>
            <a href="/recursohumano" className="hover:text-white transition-colors duration-200">Trabaja con Nosotros</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Copyright;
